export type AdminRole = 'superadmin' | 'admin' | 'support' | 'sales' | 'readonly';

export interface AdminPermissions {
  canManageUsers: boolean;
  canManageSubscriptions: boolean;
  canManagePlans: boolean;
  canManageOrders: boolean;
  canManageModules: boolean;
  canManageBetaFounders: boolean;
  canManageCMS: boolean;
  canManageQA: boolean;
  canViewSupport: boolean;
  canManageSupport: boolean;
  canViewAlerts: boolean;
  canManageBackups: boolean;
  canViewDiagnostic: boolean;
  canManageSecurity: boolean;
  canViewReports: boolean;
  canAccessCRM: boolean;
}

export function getAdminPermissions(role: AdminRole): AdminPermissions {
  switch (role) {
    case 'superadmin':
      return {
        canManageUsers: true,
        canManageSubscriptions: true,
        canManagePlans: true,
        canManageOrders: true,
        canManageModules: true,
        canManageBetaFounders: true,
        canManageCMS: true,
        canManageQA: true,
        canViewSupport: true,
        canManageSupport: true,
        canViewAlerts: true,
        canManageBackups: true,
        canViewDiagnostic: true,
        canManageSecurity: true,
        canViewReports: true,
        canAccessCRM: true,
      };

    case 'admin':
      return {
        canManageUsers: true,
        canManageSubscriptions: true,
        canManagePlans: true,
        canManageOrders: true,
        canManageModules: true,
        canManageBetaFounders: true,
        canManageCMS: true,
        canManageQA: true,
        canViewSupport: true,
        canManageSupport: true,
        canViewAlerts: true,
        canManageBackups: false,
        canViewDiagnostic: true,
        canManageSecurity: false,
        canViewReports: true,
        canAccessCRM: true,
      };

    case 'support':
      return {
        canManageUsers: false,
        canManageSubscriptions: false,
        canManagePlans: false,
        canManageOrders: false,
        canManageModules: false,
        canManageBetaFounders: false,
        canManageCMS: false,
        canManageQA: false,
        canViewSupport: true,
        canManageSupport: true,
        canViewAlerts: true,
        canManageBackups: false,
        canViewDiagnostic: false,
        canManageSecurity: false,
        canViewReports: false,
        canAccessCRM: false,
      };

    case 'sales':
      return {
        canManageUsers: false,
        canManageSubscriptions: true,
        canManagePlans: false,
        canManageOrders: true,
        canManageModules: false,
        canManageBetaFounders: true,
        canManageCMS: false,
        canManageQA: false,
        canViewSupport: false,
        canManageSupport: false,
        canViewAlerts: false,
        canManageBackups: false,
        canViewDiagnostic: false,
        canManageSecurity: false,
        canViewReports: true,
        canAccessCRM: true,
      };

    case 'readonly':
      return {
        canManageUsers: false,
        canManageSubscriptions: false,
        canManagePlans: false,
        canManageOrders: false,
        canManageModules: false,
        canManageBetaFounders: false,
        canManageCMS: false,
        canManageQA: false,
        canViewSupport: true,
        canManageSupport: false,
        canViewAlerts: true,
        canManageBackups: false,
        canViewDiagnostic: true,
        canManageSecurity: false,
        canViewReports: true,
        canAccessCRM: false,
      };

    default:
      return {
        canManageUsers: false,
        canManageSubscriptions: false,
        canManagePlans: false,
        canManageOrders: false,
        canManageModules: false,
        canManageBetaFounders: false,
        canManageCMS: false,
        canManageQA: false,
        canViewSupport: false,
        canManageSupport: false,
        canViewAlerts: false,
        canManageBackups: false,
        canViewDiagnostic: false,
        canManageSecurity: false,
        canViewReports: false,
        canAccessCRM: false,
      };
  }
}

export function getUserRole(roleString?: string): AdminRole {
  if (roleString === 'superadmin') return 'superadmin';
  return 'superadmin';
}
